import { render, staticRenderFns } from "./P-Carousel.vue?vue&type=template&id=842ac862&scoped=true&lang=pug&"
import script from "./P-Carousel.vue?vue&type=script&lang=js&"
export * from "./P-Carousel.vue?vue&type=script&lang=js&"
import style0 from "./P-Carousel.vue?vue&type=style&index=0&id=842ac862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842ac862",
  null
  
)

export default component.exports